var _mask, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLockIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 34,
    viewBox: "0 0 32 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_6975_31357",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 14.5C0 13.1193 1.11929 12 2.5 12H28.9286C30.3093 12 31.4286 13.1193 31.4286 14.5V31.5C31.4286 32.8807 30.3093 34 28.9286 34H2.5C1.11929 34 0 32.8807 0 31.5V14.5Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 14.5C0 13.1193 1.11929 12 2.5 12H28.9286C30.3093 12 31.4286 13.1193 31.4286 14.5V31.5C31.4286 32.8807 30.3093 34 28.9286 34H2.5C1.11929 34 0 32.8807 0 31.5V14.5Z",
    fill: "#2653F1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 13.3193H28.9286V10.6807H2.5V13.3193ZM30.1092 14.5V31.5H32.7479V14.5H30.1092ZM28.9286 32.6807H2.5V35.3193H28.9286V32.6807ZM1.31933 31.5V14.5H-1.31933V31.5H1.31933ZM2.5 32.6807C1.84793 32.6807 1.31933 32.1521 1.31933 31.5H-1.31933C-1.31933 33.6094 0.390643 35.3193 2.5 35.3193V32.6807ZM30.1092 31.5C30.1092 32.1521 29.5806 32.6807 28.9286 32.6807V35.3193C31.0379 35.3193 32.7479 33.6094 32.7479 31.5H30.1092ZM28.9286 13.3193C29.5806 13.3193 30.1092 13.8479 30.1092 14.5H32.7479C32.7479 12.3906 31.0379 10.6807 28.9286 10.6807V13.3193ZM2.5 10.6807C0.390644 10.6807 -1.31933 12.3906 -1.31933 14.5H1.31933C1.31933 13.8479 1.84793 13.3193 2.5 13.3193V10.6807Z",
    fill: "#2653F1",
    mask: "url(#path-1-inside-1_6975_31357)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5712 15.1429V8.85711C23.5712 4.51775 20.0534 1 15.7141 1V1V1C11.3747 1 7.85693 4.51777 7.85693 8.85715V15.1429",
    stroke: "#2653F1",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIcon);
export default __webpack_public_path__ + "static/media/lockIcon.c0e4de6a8f96ddcb92e45b27b766781c.svg";
export { ForwardRef as ReactComponent };